import { myAxios } from "./axios";

export function getDeliverables(payload = {}, { page, limit } = {}) {
    const { dealId, ...rest } = payload;
    if (!dealId) {
        throw new Error("dealId is required to fetch logs.");
    }

    const config = {
        params: {
            page,
            limit,
            ...rest,
        },
    };
    return myAxios.get(`/deliverables/get/${dealId}`, config);
}

export function getDeliverable(id) {
    return myAxios.get("/deliverables/" + id);
}

export function addDeliverable(data, dealId) {
    return myAxios.post(`/deliverables/${dealId}/`, data);
}

export function editDeliverable(id, data) {
    return myAxios.put("/deliverables/" + id, data);
}

export function deleteDeliverable(id) {
    return myAxios.delete("/deliverables/" + id);
}
